export default __webpack_public_path__ + "static/media/24.019b95c9.jpg";